<template>
   <div :style="{'background-image': `linear-gradient(180deg, rgba(0, 0, 0, .8), rgba(0, 0, 0, .8)), url(${brandBg})`}"
        id="appRoot">

      <component :config="config" :is="activeLayout()">
         <!--<transition name="fadeDown" enter-active-class="fadeInDown" leave-active-class="">-->
         <router-view :key="$route.params.id"/>
         <!--</transition>-->
      </component>

      <v-snackbar
              :bottom="snackbar.position.indexOf('bottom') > -1" :color="snackbar.type"
              :right="snackbar.position.indexOf('right') > -1"
              :timeout="3500"
              :top="snackbar.position.indexOf('top') > -1"
              multi-line
              v-model="snackbar.show">

         <v-icon class="mr-3" dark v-if="snackbar.icon">{{snackbar.icon}}</v-icon>

         {{ snackbar.message }}

         <v-btn @click.native="snackbar.show = false" dark flat icon>
            <v-icon>close</v-icon>
         </v-btn>
      </v-snackbar>

      <!--APP MODAL-->
      <v-dialog :max-width="modalParams.modalWidth" attach="#appDialog" content-class="modal-wrapper" lazy persistent
                v-model="modalParams.modalShow">
         <component :data="modalParams.modalData" :data-key="modalParams.modalKey" :is="modalParams.modalForm"
                    :key="modalRenderKey" @onClose="modalClose"
                    @onDataSaved="modalDone" modal-mode v-bind="modalParams.props"/>
      </v-dialog>

   </div>
</template>


<script>
    import '@consigmais-team/vue-common/components/msgBox/index';
    import AdminLayout from '@consigmais-team/vue-common/layout/AdminLayout';
    import EmptyLayout from '@consigmais-team/vue-common/layout/EmptyLayout';
    import AppEvents from './event';
    import Config from './config';
export default {
  data: () => ({
      snackbar: {
          show: false,
          message: '',
          type: '',
          icon: '',
          position: 'bottom'
      },

      brandLogo: '',
      brandName: '',

      modalParams: {
          props: {},
          modalWidth: 450,
          modalShow: false,
          modalData: null,
          modalKey: null,
          modalForm: null,
          doneCallback: null
      },

      modalRenderKey: 0

  }),

  computed: {
      config () {
          return Config;
      },

      brandBg () {
          let brand = window.location.hostname.split('.')[0];
          if (['localhost', 'consigmais'].indexOf(brand) >= 0) {
              brand = 'app';
          }

          return `${this.$api.serverHost}/files/brands/${brand}/bg-afiliado.png`;
      }
  },

  beforeCreate () {
      window.onfocus = (e) => {
          this.onFocus(e);
      };
  },

  created () {
      AppEvents.forEach(item => {
          this.$on(item.name, item.callback);
      });
      window.addEventListener('resize', this.onPageResize);
      window.getApp = this;

      this.getBrand();
  },

  methods: {
      getBrand() {
         this.$api.dataService.getPublicData('getBrandSimple', {})
            .then((e) => {
               this.brandLogo = e.brandLogo;
               this.brandName = e.brandName;

               const favicon = e.brandFavicon;
               document.getElementById("favicon").href = favicon;
               document.title = this.brandName;
            });
      },

      activeLayout () {
         //  console.log('********** activeLayout *************');
         //  console.log(this.$route.name, this.$route.meta);
          if (this.$route.meta.layout) {
              return (this.$route.meta.layout === 'EmptyLayout') ? EmptyLayout : AdminLayout;
          } else {
              let token = window.localStorage.getItem('stAuthToken') || '';
              return (token) ? AdminLayout : EmptyLayout;
          }
      },

      onFocus (evt) {
          console.log('ChequesWeb focused!');
          /*if (window.sessionToken && window.sessionToken !== window.localStorage.getItem('authToken')) {
              this.$message({
                  type: 'error',
                  message: `Este usuário não está mais conectado!`
              });

              this.$router.replace({name: 'login'});

          }*/
      },

      onPageResize () {
          window.getApp.$emit('APP_MAIN_CONTENT_RESIZE');
      },

      showModal (routeName, params = {}) {
          this.modalParams = Object.assign({}, this.modalParams, params);

          for (let i = 0; i < this.$router.options.routes.length; i++) {
              let r = this.$router.options.routes[i];
              if (r.name === routeName) {
                  this.modalParams.modalForm = r.component;

                  this.modalParams.props = Object.assign({}, r.props, params.props);
                  console.log(JSON.parse(JSON.stringify(this.modalParams)));

                  // console.log(this.modalParams, params);

                  this.modalRenderKey = +new Date();
                  this.modalParams.doneCallback = params.doneCallback;

                  this.modalParams.modalShow = true;
                  break;
              }
          }

      },

      modalDone (data) {
          if (this.modalParams.doneCallback) {
              this.modalParams.doneCallback(data);
          }

          this.modalParams.modalShow = false;
      },

      modalClose () {
          this.modalParams.modalShow = false;
          this.modalParams.modalForm = null;
      }

  }
};
</script>

<style lang="stylus">
   .small-radio > label {
      font-size: 12px !important;
   }

   .setting-fab
      top: 50% !important
      right: 0
      border-radius: 0

   .page-wrapper
      height: 100%
      background-color: #EFEFEF

   .page-wrapper > .crud-wrapper
      padding: 20px 20px 15px
      background-color: #EFEFEF


   .crud-wrapper
      background-color: #EFEFEF
      height: 100%


   .crud-form-wrapper
      background-color: #EFEFEF
      padding-top: 55px !important
      padding-left: 0px !important
      padding-right: 0px !important
      padding-bottom: 0px !important

   .modal-wrapper {
      background-color: #EFEFEF;
   }

   .v-input {
      margin-top: 8px;
   }

   #appRoot
      background-position: center center
      background-size: cover;
      background-repeat: no-repeat;
      background-attachment: fixed;

   #inspire {
      background-color: #EFEFEF;
      color: white;
   }

   .v-input__icon.v-input__icon--append {
      cursor: pointer;
   }

   .v-input__slot {
      margin-bottom: 3px;
   }


   .v-expansion-panel__header {
      padding: 10px 8px;
   }

   .dx-group-row {
      background-color: #e7e7e7 !important;
      color: #353535 !important;
   }

   .dx-datagrid-rowsview .dx-selection.dx-row > td,
   .dx-datagrid-rowsview .dx-selection.dx-row:hover > td {
      font-weight: 600;
      color: #2b343a;
   }

   .dx-datagrid-header-panel, .dx-toolbar-items-container, .dx-datagrid-pager {
      background-color: #EFEFEF;
   }

   .dx-datagrid-group-panel {
      padding-top: 3px;
   }

   .dx-datagrid-rowsview .dx-row.dx-data-row.dx-state-hover > td {
      background-color: #a3bbc9 !important;
      color: inherit;
   }

   .dx-datagrid-content .dx-datagrid-table .dx-row > td {
      vertical-align middle;
   }

   .btn-grid-command {
      min-width: 30px;
      font-size: 22px;
      color: gray;
      margin-left: 5px;
      cursor: pointer;
   }

   .btn-grid-flag {
      min-width: 30px;
      font-size: 18px;
      color: silver;
   }

   .btn-grid-flag.active {
      color: goldenrod;
   }

   /* Tooltip container */
   .gridTooltip {
      position: relative;
      display: inline-block;
   }

   /* Tooltip text */
   .cellTooltip {
      overflow: visible !important;
   }

   .gridTooltip .tooltiptext {
      visibility: hidden;
      font-family: 'Helvetica Neue', 'Segoe UI', Helvetica, Verdana, sans-serif;
      font-weight: 400;
      font-size: 14px;
      min-width: 100px;
      height: 30px;
      background-color: #555;
      color: #fff;
      text-align: center;
      padding: 7px 10px;
      border-radius: 6px;

      /* Position the tooltip text */
      position: absolute;
      z-index: 10000;
      bottom: 125%;
      top: -5px;
      right: 105%;
      margin-left: -60px;

      /* Fade in tooltip */
      opacity: 0;
      transition: opacity 0.3s;
   }

   /* Tooltip arrow */
   .gridTooltip .tooltiptext::after {
      content: " ";
      position: absolute;
      top: 50%;
      left: 100%; /* To the right of the tooltip */
      margin-top: -5px;
      border-width: 5px;
      border-style: solid;
      border-color: transparent transparent transparent #555;
   }

   /* Show the tooltip text when you mouse over the tooltip container */
   .gridTooltip:hover .tooltiptext {
      visibility: visible;
      opacity: 1;
   }

   .large-input {
      margin-top: -4px;
   }

   .large-input input {
      font-size: 1.2em;
   }

   .v-input--has-state.error--text .v-label {
      animation: none !important;
   }

   .v-tooltip {
      z-index: 550;
   }

   .v-text-field__details {
      max-height: 12px;
   }

   .aLabel {
      display: block;
      font-size: 12px;
      margin-bottom: 2px;
   }

   .text-truncate {
      width: 95%;
      display: inline-block;
   }

   .aLink {
      cursor: pointer;
   }

   .aLink:hover {
      color: dodgerblue;
   }

   .outlined {
      border-style: solid;
      border-color: lightgray;
      border-width: 1px;
      border-radius: 3;
   }

   .clean-style.v-text-field>.v-input__control>.v-input__slot:before {
      border-style: none;
   }
   .clean-style.v-text-field>.v-input__control>.v-input__slot:after {
      border-style: none;
   }
   .clean-style.v-text-field>.v-input__control>.v-input__slot {
      background-color: white;
   }
   .clean-style.v-input .v-input__slot {
      border-radius: 5px;
   }
   .clean-style.theme--dark.v-input .v-input__slot {
      border-radius: 5px;
   }

</style>


// WEBPACK FOOTER //
// src/App.vue